var map = {
	"./cast.svg": "b274",
	"./cast_connected.svg": "d5ea",
	"./computer.svg": "16db",
	"./desktop_mac.svg": "5d31",
	"./desktop_windows.svg": "c3a9",
	"./developer_board.svg": "85cd",
	"./device_hub.svg": "99bd",
	"./devices_other.svg": "4af0",
	"./dock.svg": "84a2",
	"./gamepad.svg": "15dd",
	"./headset.svg": "e583",
	"./headset_mic.svg": "cfea",
	"./keyboard.svg": "e720",
	"./keyboard_arrow_down.svg": "fc00",
	"./keyboard_arrow_left.svg": "a288",
	"./keyboard_arrow_right.svg": "fbb5",
	"./keyboard_arrow_up.svg": "b777",
	"./keyboard_backspace.svg": "6322",
	"./keyboard_capslock.svg": "b09d",
	"./keyboard_hide.svg": "c7ef",
	"./keyboard_return.svg": "6dd76",
	"./keyboard_tab.svg": "61f8",
	"./keyboard_voice.svg": "a6fa",
	"./laptop.svg": "2bc3",
	"./laptop_chromebook.svg": "9ba6",
	"./laptop_mac.svg": "1136",
	"./laptop_windows.svg": "0fd3",
	"./memory.svg": "131b",
	"./mouse.svg": "381f",
	"./phone_android.svg": "a074",
	"./phone_iphone.svg": "6b8c",
	"./phonelink.svg": "0bd0",
	"./phonelink_off.svg": "820b",
	"./power_input.svg": "676a",
	"./router.svg": "a7c6",
	"./scanner.svg": "055b",
	"./security.svg": "0b64",
	"./sim_card.svg": "45f4",
	"./smartphone.svg": "d68c",
	"./speaker.svg": "1f06",
	"./speaker_group.svg": "d5c1",
	"./tablet.svg": "a660",
	"./tablet_android.svg": "25e4",
	"./tablet_mac.svg": "18dc",
	"./toys.svg": "5a6f",
	"./tv.svg": "b052",
	"./videogame_asset.svg": "97ad",
	"./watch.svg": "84ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a088";